import Bluebird from 'bluebird'
import {generatePersonalizedArtworkV4, generatePersonalizedArtworkV6} from '../services/MockupGeneratorServices'
import {createProductPODV4, deleteProduct, uploadImageGallery} from '../services/ProductServices'
import {getCurrentStore} from '../services/CurrentStoreServices'
import {getDefaultBaseURL} from '../services/CreateStoreAPIService'
import {getLinksUploadArtwork} from '../services/ArtworkTemplateServices'
import axios from 'axios'
import {setLocalData} from '../services/StorageServices'

export const getInfomationBackground = (type, currentBgImage, wPreview = 200, hPreview = 200) => {
    let marginTop = (hPreview - 200) / 2
    let marginLeft = (wPreview - 200) / 2
    let width = 200
    let height = 200
    let x = 0
    let y = 0
    if (type === 'fit' || type === 'original') {
        if (currentBgImage.naturalWidth < 200 && currentBgImage.naturalHeight < 200) {
            width = currentBgImage.naturalWidth
            height = currentBgImage.naturalHeight
            x = 76 - width / 2
            y = 76 - height / 2
        } else if (currentBgImage.naturalWidth > 200 && currentBgImage.naturalHeight < 200) {
            height = currentBgImage.naturalHeight / (currentBgImage.naturalWidth / 200)
            y = 76 - height / 2
        } else if (currentBgImage.naturalWidth < 200 && currentBgImage.naturalHeight > 200) {
            width = currentBgImage.naturalWidth / (currentBgImage.naturalHeight / 200)
            x = 76 - width / 2
        } else {
            if (currentBgImage.naturalWidth > currentBgImage.naturalHeight) {
                height = currentBgImage.naturalHeight / (currentBgImage.naturalWidth / 200)
                y = 76 - height / 2
            } else if (currentBgImage.naturalWidth < currentBgImage.naturalHeight) {
                width = currentBgImage.naturalWidth / (currentBgImage.naturalHeight / 200)
                x = 76 - width / 2
            }
        }
    }
    return {
        width,
        height,
        x: x + marginLeft,
        y: y + marginTop,
    }
}

export const uploadArtworkV6 = async (productIDCreated, productCreatedType, personalizedArtworkPayload = []) => {
    await Bluebird.map(
        personalizedArtworkPayload,
        async (payload) => {
            const storeId = getCurrentStore()
            const base_url = getDefaultBaseURL()
            const newPayload = {
                ...payload,
                base_url,
                site_id: storeId,
                product_id: productIDCreated
            }
            const resGenPersonalize = await generatePersonalizedArtworkV6(newPayload)
            if (!resGenPersonalize.success) throw new Error(resGenPersonalize.message)
        },
        {concurrency: 2}
    )
}

export const uploadArtworkCapture = async (artworksParam) => {
    const artworks = artworksParam.filter(item => !!item.srcBlob || !!item.src)
    if (artworks.length > 0) {
        const {data} = await getLinksUploadArtwork({limit: artworks.length})

        const presignedUrls = data || []
        if (presignedUrls.length !== artworks.length) throw new Error('Failed to get presigned url')

        return await Bluebird.map(artworks, async (artwork, index) => {
            const presignedUrl = presignedUrls[index]
            const fileReader = new FileReader()
            await new Promise((resolve, reject) => {
                fileReader.onload = function () {
                    resolve()
                }
                fileReader.onerror = function () {
                    reject(fileReader.error)
                }

                fileReader.readAsArrayBuffer(artwork.srcBlob)
            })

            const buffer = fileReader.result

            const response = await axios.put(presignedUrl, buffer, {
                headers: {
                    'Content-Type': 'image/png',
                },
            })

            return response.config.url?.split('?')[0]
        })
    } else {
        return []
    }
}

export const uploadArtworkV4 = async (productIDCreated, personalizedArtworkPayload) => {
    await Bluebird.map(
        personalizedArtworkPayload,
        async (payload) => {
            const resGenPersonalize = await generatePersonalizedArtworkV4({
                ...payload,
                product_id: productIDCreated
            })
            if (!resGenPersonalize.success) throw new Error(resGenPersonalize.message)
        },
        {concurrency: 2}
    )
}

export const createProductCombine = async (params) => {
    const {product, personalizedArtworkPayload, variants, galleryImage,  currentBgImage, productCreatedType = '', designs, artworks = [], size_guide} = params
    let productIDCreated = ''

    try {
        const {attributes, collections} = product

        const filteredAttributes = attributes.map((attribute) => {
            const filteredValues = attribute.values.filter((value) =>
                variants.some((variant) =>
                    variant.attributes.some(
                        (variantAttribute) =>
                            variantAttribute.name === attribute.name && variantAttribute.value_code === value.code,
                    ),
                ),
            )

            return {...attribute, values: filteredValues}
        })

        const payload1 = {
            ...product,
            collections: Array.isArray(collections) ? collections.map((collection) => collection.value) : [],
            productLine: {
                variants,
                attributes: filteredAttributes
            },
            size_guide
        }
        delete payload1.mockups


        // 1. create a new product
        const resCreateProduct = await createProductPODV4(payload1)
        if (!resCreateProduct.success) throw new Error(resCreateProduct.message)

        productIDCreated = resCreateProduct.data._id

        // 2. upload artwork personalize for product
        if (productCreatedType === 'regularNoTemplate' || productCreatedType === 'regularHasTemplate' || productCreatedType === 'combineLayout' || productCreatedType === 'type2D') {
            await uploadArtworkV6(productIDCreated, productCreatedType, personalizedArtworkPayload, product, designs, variants, artworks)
        } else {
            await uploadArtworkV4(productIDCreated, personalizedArtworkPayload)
        }

        // 3. upload gallery for product
        // if (galleryImage) {
        //     const resUploadGallery = await uploadImageGallery(productIDCreated, {
        //         galleryUrls:
        //             galleryImage.map(img => img.replace(
        //                 'regular.jpg',
        //                 `background:${currentBgImage?.file
        //                     ? encodeURIComponent(
        //                         encodeURIComponent(personalizedArtworkPayload[0].keyBackground))
        //                     : 'default'}/regular.jpg`)
        //             )
        //     })
        //     if (!resUploadGallery.success) throw new Error(resUploadGallery.message)
        // }

        setLocalData('status_capture_background', '')

        // 4.Redirect to product detail page
        const productDetailUrl = `${process.env.REACT_APP_BASE_URL}/a/products/${productIDCreated}`
        return window.open(productDetailUrl, '_self')


        // 4. activate product
        // const resActiveProduct = await activateProductPOD(productIDCreated)
        // if (!resActiveProduct.success) throw new Error(resActiveProduct.message)
        //
        // setCampaign((prevCampaigns) => ({
        //     ...prevCampaigns,
        //     status: 'Completed',
        // }))
        //
        // // 5. Request get variant images
        // const resSearchVariants = await searchVariants(productIDCreated, [], {limit: 10000})
        // if (resSearchVariants?.success) {
        //     const images = resSearchVariants.data.variants.reduce((accumulator, variant) => {
        //         const {image_uris = []} = variant
        //         return accumulator.concat(image_uris)
        //     }, [])
        //
        //     setCampaign((prevCampaigns) => ({
        //         ...prevCampaigns,
        //         mockup: {
        //             total: images.length,
        //             images,
        //         },
        //     }))
        // }
        // return true
    } catch (error) {
        deleteProduct(productIDCreated)
        // setCampaign((prevCampaigns) => ({
        //     ...prevCampaigns,
        //     status: 'Error',
        //     error: error.message
        // }))
        // throw new Error(error)
    } finally {

    }
}
